import React, { ReactElement, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import Secured from '../../Secured';
import { canExportVznesenePripomienky } from '../../../function/permissions';
import exportIcon from '../icons/export.svg';
import { useUserContext } from '../../../context/UserContext';
import { exportVznesenePripomienky } from '../../../client/exportVznesenePripomienkyClient';
import downloadFile from '../../../function/downloadFile';
import { useErrorMessageContext } from '../../../context/ErrorMessageContext';
import { useSecurityContext } from '../../../context/SecurityContext';

interface Props {
  setOpenDropdown: (opened: boolean) => void;
}

const ExportPripomienokPredkladatelButton = ({ setOpenDropdown }: Props): ReactElement => {
  const { legislationProcess, pouzivatel } = useUserContext();
  const [disabled, setDisabled] = useState<boolean>(false);
  const { displayError } = useErrorMessageContext();
  const { accessToken, organizationId } = useSecurityContext();
  const headers = {
    ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    ...(organizationId && { OrganizationId: encodeURIComponent(organizationId) }),
  };

  const handleClick = async (): Promise<void> => {
    setDisabled(true);
    exportVznesenePripomienky(
      legislationProcess.legMaterialUuid,
      { headers },
    ).then((response) => {
      downloadFile(response.data.fileName, response.data.blob);
      setDisabled(false);
      if (setOpenDropdown) {
        setOpenDropdown(false);
      }
    }).catch(error => {
      setDisabled(false);
      if (error.response?.status === 404) {
        displayError('K materiálu nie je pridaná žiadna pripomienka.');
      } else if (error.response?.status !== 200) {
        displayError('Z technických príčin nebolo možné vykonať požadovanú akciu. Skúste neskôr.');
      }
    });
  };

  return (
    <Secured
      additionalCheck={canExportVznesenePripomienky(pouzivatel, legislationProcess)}
    >
      <li key="Export vznesenych pripomienok" className="action-item">
        <div className="icon-wrapper">
          <img src={exportIcon} className="icon" alt="Export vznesenych pripomienok" />
        </div>
        <button
          disabled={disabled}
          type="button"
          className="export-pripomienok-button button-inline-text idsk-link"
          onClick={handleClick}
        >Export vznesených pripomienok
          {disabled ? <FontAwesomeIcon className="spinner" icon={faSpinner} spin /> : null}
        </button>
      </li>
    </Secured>
  );
};

export default ExportPripomienokPredkladatelButton;
